export default {
  useDocumentCount: (field, tab) => {
    return true
  },
  getPerPage: (tab) => {
    return 15
  },
  getHead: () => {
    return [
      {name: 'No.', style:{minWidth:'100px', width:'100px'}},
      {name: '부서명', key: 'meta.com_name', isNoSort: true},
      {name: '팀명', key: ''},
      {name: '사업장명', key: 'field_name'},
      {name: '담당주무관', key: 'manager_name'},
      {name: '사업기간'},
      {name: '사업금액(원)', key: 'deposit_amount'},
      {name: '사업장주소', key: 'address'},
    ]
  } ,
  getCol: (index, row, func) => {
    try {
      // func.meta : FieldsList.getMeta(row) 로 파싱된 meta 객체 (파싱 실패 시 {})
      const meta = func.meta || {}
      switch (index) {
        case 0: return func.no
        // 부서명 (작성 페이지 meta.com_name)
        case 1: return meta.com_name || '-'
        // 팀명 (작성 페이지 meta.team_company_list)
        case 2: {
          const teamCompanyList = meta.team_company_list
          return Array.isArray(teamCompanyList) && teamCompanyList.length > 0 ? teamCompanyList.map((team) => team.com_name).join(', ') : '-'
        }
        case 3: return row.field_name
        case 4: return row.manager_name
        case 5: {
          const work_begin_at = row.work_begin_at
          const work_end_at = row.work_end_at
          let date = ''
          if (work_begin_at) date += func.date(work_begin_at)

          if (!!work_begin_at || !!work_end_at) date += "~"
          else date += "-"

          if (work_end_at) date += func.date(work_end_at)
          return date
        }
        case 6: return {
          style: {textAlign: 'center'}, // textAlign 은 디폴트가 center 이므로 생략 가능
          value: !!row.deposit_amount ? func.comma(row.deposit_amount) : "-"
        }
        case 7: return row.address
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  loadFieldList (searchData) {
    const params = {}
    // 연도 검색
    if (searchData.targetYear) {
      params.work_begin_before = `${searchData.targetYear}-01-31`;
      params.work_end_after = `${searchData.targetYear}-12-01`;
    }

    // 부서명 검색: 작성 페이지에서 저장한 meta.com_name 으로 필터링한다. (서버는 부분일치 검색)
    // 도급·용역·위탁 사업 프로젝트에는 회사 트리(소속 업체)가 연결되어 있지 않아,
    // 직영사업장 목록처럼 parentCompanyId 로는 검색할 수 없다.
    if (searchData.companyName) {
      params.metaKey = 'com_name'
      params.metaValue = searchData.companyName
    }

    // 키워드
    params.keyword = searchData.keyword
    return params
  },
}
